import { CHANGE_ORGANIZATION } from "./actionTypes"

export const changeCurrentOrganization = organization => {
  return {
    type: CHANGE_ORGANIZATION,
    payload: organization ,
  }
}
